import React from 'react';
import { CustomDatePicker, DateWrapper } from "../../styles";
import { DatePicker } from "antd";
import PropTypes from 'prop-types';
import { DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import { oneYearBackDate } from "../../../../../../utils/commonUtil";

import moment from "moment";
const cDate = new Date();
const todayDate = moment(cDate).format('MM/DD/YYYY');
  
    export function disabledDate(current) {
      return current && current > moment().endOf('day');
    }

    export function endDisabledDate(value,current){
      if(value[0]){
      return current && (current <= moment(value[0] ? value[0] : null, "MM/DD/YYYY") || current > moment().endOf('day'));
      }else{
        return current && current > moment().endOf('day');
      }
    }

    export function startDisabledDate(value,current){
      if(value[1]){
      return current && (current > moment(value[1] ? value[1] : null, "MM/DD/YYYY") || current > moment().endOf('day'));
      }else{
        return current && current > moment().endOf('day');
      }
    }

export function DateSelectorComponent(props) {
    return (
      <DateWrapper >
        {window.screen.availWidth < 576 ? <DisplayFlex className="activityMobileWrapper" style={{ flexDirection: "column" }}>
        <div id="contrActivityStartCalender">
          <DatePicker format="MM/DD/YYYY"
          data-test="date-picker"
          getCalendarContainer={() => document.getElementById("contrActivityStartCalender")} 
            disabledDate={(currentDate) => startDisabledDate(props.value, currentDate)} 
            value={ props.isFilterClicked ? ( props.displayDates && props.displayDates.length && props.displayDates[0] ? moment(props.displayDates[0],"MM/DD/YYYY") : props.displayDates && props.displayDates.length && props.displayDates[0])
            : (props.value &&  props.value.length && props.value[0] ? moment(props.value[0],"MM/DD/YYYY") : props.value && props.value.length && props.value[0])} 
            placeholder="Start Date" 
            onChange={(dateString) => props.mobileStartDate(dateString)} 
           />
          </div>
          <div id="contrActivityEndCalender">
          <DatePicker format="MM/DD/YYYY" 
             data-test="date-picker-end"
            getCalendarContainer={() => document.getElementById("contrActivityEndCalender")} 
            disabledDate={(currentDate) => endDisabledDate(props.value, currentDate)} 
            value={ props.isFilterClicked ? ( props.displayDates && props.displayDates.length && props.displayDates[1] ? moment(props.displayDates[1],"MM/DD/YYYY") : props.displayDates && props.displayDates.length && props.displayDates[1])
            : (props.value && props.value.length && props.value[1] ? moment(props.value[1],"MM/DD/YYYY") : props && props.value && props.value.length && props.value[1])} 
            placeholder="End Date" 
            onChange={(dateString) => props.mobileEndDate(dateString)} />
          </div>
        </DisplayFlex>
          : <div id="contrActivityCalender"><CustomDatePicker
          data-test="custom-picker"
          format="MM/DD/YYYY"
          className="contributionActivity-DateInput"
            placeholder={["Start Date", "End Date"]}
            defaultValue={[ props && props.values && props.values[0], moment(todayDate, "MM/DD/YYYY")]}
            value={props && props.values && props.values.length ? [moment(props.values[0],"MM/DD/YYYY"), moment(props.values[1],"MM/DD/YYYY")] : [props.values && props.values[0], props.values && props.values[1]] }
            disabledDate={disabledDate}
            getCalendarContainer={() => document.getElementById("contrActivityCalender")}
            open={props && props.open}
            allowClear
            onChange={(value, dateString) => props.toTimeFrame({value,dateString})}
          /></div>
        }
      </DateWrapper>
    );
  }

  DateSelectorComponent.propTypes = {
    toTimeFrame: PropTypes.func,
    mobileStartDate: PropTypes.func,
    mobileEndDate: PropTypes.func ,
    isFilterClicked: PropTypes.bool ,
    values: PropTypes.array ,
    open: PropTypes.bool ,
    displayDates: PropTypes.array
  }

export default DateSelectorComponent;